export const isFreshwaysEori = (eori = '') => {
  return eori.toUpperCase() === 'GB444234413000';
};
